<template>
  <div id="integral">
    <div class="userInfo-box">
      <!-- <van-nav-bar
      title="我的积分"
      left-text=""
      left-arrow
      @click-left="onClickLeft"
/> -->

      <section class="jifen">
        <div class="explain" @click="ruleClick">规则说明</div>
        <div class="number">{{ integral.current_point }}</div>
        <div class="detailNum" @click="godetail()">
          积分明细<van-icon name="arrow" />
        </div>
      </section>

      <div class="tabTotail">
        <div @click="scorelocal">
          <div class="tabNumber">{{ integral.rank }}</div>
          <div class="Name">
            <img src="@/assets/images/ent.png" />企业当前排名<van-icon
              name="arrow"
            />
          </div>
        </div>
        <div class="solid_id"></div>
        <div>
          <div class="tabNumber">{{ integral.personYearPoint }}</div>
          <div class="Name">
            <img src="@/assets/images/person.png" />个人累计积分
          </div>
        </div>
      </div>

      <div class="jifenRule">
        <div class="ruleNme">积分规则</div>
        <div class="ruleNme-font">
          今日累计{{ integral.personTodayPoint }}积分
        </div>
      </div>
      <div class="choice">
        <div class="choice_left" @click="timePickerStart = true">
          <b>{{ choiceText }}</b>
          <van-icon v-if="!timePickerStart" name="arrow-down" />
          <van-icon v-else name="arrow-up" />
        </div>
        <span @click="seeReceive" :class="{ 'choice-color': receive }"
          >查看可领取的</span
        >
      </div>
      <div class="bottom-box">
        <div class="tab_th" v-for="(item, index) in List" :key="index">
          <div class="title">{{ item.title }}</div>
          <div class="tab_tr">
            <div class="tab_lab">
              {{ item.type | fnNeedStatus }}{{ item.point ? item.point : 0 }}分
            </div>
            <div
              class="while_progress"
              v-if="
                !(item.pointType === 1 && item.receiveStatus === 0)
                  ? item.dayLimit !== 0
                  : false
              "
            >
              <div class="progress" v-if="item.dayLimit && item.dayLimit !== 0">
                <span class="proess_number"
                  >{{ item.completed }}/{{
                    item.dayLimit ? item.dayLimit : 0
                  }}</span
                >
              </div>
              <div
                v-if="item.dayLimit && item.dayLimit !== 0"
                :class="item.completed > 0 ? 'ent_progress' : ''"
                :style="{ width: (item.completed / item.dayLimit) * 100 + '%' }"
              ></div>
            </div>
            <div
              class="tab_lab"
              v-if="
                !(item.pointType === 1 && item.receiveStatus === 0)
                  ? item.dayLimit === 0 || item.dayLimit === null
                  : false
              "
            >
              已完成{{ item.completed }}次
            </div>
            <div
              class="received"
              v-if="item.pointType === 1 && item.receiveStatus === 0"
              @click="receivePoint(item.type)"
            >
              领取
            </div>
          </div>
          <div class="tab_lab" v-if="item.dayLimit && item.dayLimit !== 0">
            每日上限{{ item.dayLimit }}次
          </div>
          <div
            class="tab_lab"
            v-if="item.dayLimit == 0 || item.dayLimit == null"
          >
            每日无上限
          </div>
          <van-divider />
        </div>
      </div>
    </div>
    <van-popup
      v-model="show"
      closeable
      :style="{ height: '80%', width: '80%', padding: '0 0 20px 0' }"
    >
      <div class="text_rule">积分规则</div>
      <div class="text_van">
        积分是“丽企之家”平台对企业用户使用软件情况的行为分析数据，也是兑换奖励的依据。本规则最终解释权归“丽企之家”平台所有。<br />

        严禁利用刷分、作弊软件等谋取利益。一经发现将严肃处理。
      </div>
      <div>
        <div class="text—span"><br />本平台对积分获取做如下规定：</div>
        <div
          v-for="(item, index) in nolist"
          :key="index"
          class="text—span text-span1"
        >
          <div :class="{ 'item-point': item.title }">{{ item.title }}</div>
          <div class="item-text">
            {{ item.text
            }}<span v-if="item.dayLimit != 0"
              >每天上限{{ item.dayLimit }}次</span
            ><span v-if="item.dayLimit === 0">每天无上限</span>
          </div>
        </div>
      </div>
      <div class="text—span">
        <br />
        *注：积分有效期自发放日起当年有效，每年12月31日清零，不设上限
        员工积分转换成企业积分，转换比例待定
      </div>
    </van-popup>

    <!-- 首次进入页面 -->
    <van-popup v-model="popShow" closeable>
      <img src="@/assets/images/sign.png" class="popimg" />
      <div class="signsuccess">签到成功</div>
      <div class="getsign">恭喜您获得{{ signSucess }}积分</div>
      <van-button type="info" class="vanbtn" @click="subBtn"
        >开心收下</van-button
      >
    </van-popup>
    <!--  类别筛选 -->
    <van-popup v-model="timePickerStart" round position="bottom">
      <van-picker
        show-toolbar
        title=""
        :columns="columns"
        value-key="labelName"
        @confirm="onConfirm"
        @cancel="timePickerStart = false"
      />
    </van-popup>
  </div>
</template>
<script>
import {
  listUserDetail,
  getPointRuleText,
  codeSignFirst,
  getLabelList,
  receivePointRule
} from '@api/lishui/integral'
import { newSaveRecord, newSaveUVRecord } from '@api/lishui'
import { Dialog } from 'vant'
import { getLocalStorage, setLocalStorage, removeLocalStorage } from '@utils'
import { Toast } from 'vant'
let that
export default {
  name: 'Integral',
  props: {},
  data() {
    return {
      integral: {},
      timePickerStart: false,
      columns: [],
      message: '',
      List: [
        { title: '每日签到', lab: '员工每日签到加1分', set: '每日上限1次' },
        { title: '每日签到', lab: '员工每日签到加1分', set: '每日上限1次' }
      ],
      nolist: [],
      show: false,
      popShow: false,
      form: {},
      userInfo: JSON.parse(getLocalStorage('lishuiUserInfo'))
        ? JSON.parse(getLocalStorage('lishuiUserInfo'))
        : {},
      point: [],
      creditCode: getLocalStorage('creditCode'),
      formDataProp: [
        {
          value: 1,
          name: '填写资料，成功提交获得'
        },
        {
          value: 2,
          name: '一个员工加入，获得'
        },
        {
          value: 3,
          name: '企业员工签到，获得'
        },
        {
          value: 4,
          name: '浏览一个页面获得'
        },
        {
          value: 5,
          name: '前往丽水专区，点击员工考勤，一次获得'
        },
        {
          value: 6,
          name: '填写成功提交一次问卷，获得'
        },
        {
          value: 7,
          name: '观看直播或视频加'
        },
        {
          value: 8,
          name: '码上直播，观看一次直播加'
        },
        {
          value: 9,
          name: '参与报名一次活动，获得'
        },
        {
          value: 10,
          name: '活动开始后进行签到，获得'
        },
        {
          value: 11,
          name: '查看通知公告详情，获得'
        },
        {
          value: 12,
          name: '分享通知公告，获得'
        },
        {
          value: 13,
          name: '购买服务产品成功下订单，获得'
        },
        {
          value: 14,
          name: '企业提交白名单申领材料，获得'
        }
      ],
      signSucess: '',
      receive: false,
      choiceText: '全部',
      choiceId: ''
    }
  },
  filters: {
    fnNeedStatus(status) {
      const name = that.formDataProp.find(v => {
        return v.value === status
      })
      return name ? name.name : ''
    }
  },
  created() {
    this.firstData()
    this.getData()
    this.getLabel()
  },
  beforeMount() {
    that = this
  },
  methods: {
    // 埋点
    buriedPoint() {
      const params = {
        applyName: this.$route.meta.title,
        creditCode: this.userInfo.creditCode,
        entName: this.userInfo.entName,
        mobile: this.userInfo.mobile
      }
      JSSDK_QYM.sendData({
        pageUrl: this.$route.path,
        pageId: window.location,
        pageName: this.$route.meta.title,
        userAgent: ''
      })
      newSaveRecord(params).then(res => {})
      newSaveUVRecord(params).then(res => {})
    },
    // 标签列表
    getLabel() {
      getLabelList().then(res => {
        console.log(res)
        this.columns = res.data.data
        this.columns.unshift({ labelName: '全部', id: '' })
      })
    },
    seeReceive() {
      this.buriedPoint()
      if (this.receive) {
        this.receive = false
      } else {
        this.receive = true
      }
      this.getData()
    },
    onClickLeft() {
      this.$router.go(-1)
    },
    scorelocal() {
      // this.buriedPoint()
      this.$router.push({ path: '/enterprisepoints/scoreRanking' })
    },
    ruleClick() {
      this.show = true
      this.getRule()
      this.buriedPoint()
    },
    getData() {
      const params = {
        creditCode: this.creditCode,
        // mobile: this.userInfo.mobile,
        pointType: this.receive ? 1 : '',
        pointLabelId: this.choiceId
      }
      listUserDetail(params).then(res => {
        if (res.data.code === '0000') {
          this.integral = res.data.data
          this.List = res.data.data.listPointRule
        }
      })
    },
    showPopup() {
      this.popShow = true
    },
    subBtn() {
      this.popShow = false
      this.getData()
    },
    getRule() {
      getPointRuleText().then(res => {
        if (res.data.code === '0000') {
          this.nolist = res.data.data
          this.nolist.map(item => {
            let text = ''
            item.detailDtoList.forEach(val => {
              text = text + val.content + ';'
            })
            item.text = text
          })
        }
      })
    },
    firstData() {
      const params = {
        // creditCode: this.userInfo.creditCode,
        // mobile: this.userInfo.mobile,
        // staffName: this.userInfo.staffName,
        // staffType: this.userInfo.staffType,
        // addresss: this.userInfo.addresss,
        // postOffice: this.userInfo.postOffice,
        // isFr: this.userInfo.isFr
        creditCode: '',
        mobile: '',
        staffName: '',
        staffType: '',
        addresss: '',
        postOffice: '',
        isFr: ''
      }
      codeSignFirst(params).then(res => {
        if (res.data.code === '0000') {
          // signSucess==0是不是首次进入  signSucess==1是首次进入
          if (res.data.data > 0) {
            this.signSucess = res.data.data
            this.showPopup()
          }
        }
      })
    },
    godetail() {
      // this.buriedPoint()
      this.$router.push({ path: '/enterprisepoints/integralDetails' })
    },
    receivePoint(e) {
      const params = {
        pointRuleType: e
      }
      receivePointRule(params).then(res => {
        Toast('领取成功')
        this.getData()
      })
    },
    onConfirm(value, index) {
      // console.log(`当前值: ${value.id}, 当前索引: ${index}`)
      this.timePickerStart = false
      this.choiceText = value.labelName
      this.choiceId = value.id
      this.getData()
    }
  }
}
</script>
<style lang="scss" scoped>
.userInfo-box {
  background: #f0f5f9;
  padding-bottom: 20px;
  /deep/.van-nav-bar__title {
    font-size: 16px;
    color: rgba(0, 0, 0, 1);
    height: 36px;
    line-height: 36px;
  }
  /deep/.van-nav-bar .van-icon {
    color: rgba(153, 153, 153, 1);
  }
  .explain {
    position: absolute;
    top: 10%;
    right: 0;
    font-size: 14px;
    color: rgba(102, 102, 102, 100);
    padding: 10px 20px;
    background: #fff;
    border-radius: 25px 0 0 25px;
  }
  .jifen {
    background: url('~@/assets/images/bg.png') no-repeat;
    background-size: 100% 100%;
    height: 150px;
    width: 100%;
  }
  .number {
    text-align: center;
    padding-top: 50px;
    font-size: 32px;
    font-weight: 600;
  }
  .detailNum {
    text-align: center;
    color: rgba(153, 153, 153, 100);
    font-size: 14px;
    font-weight: 500;
  }
  .tabTotail {
    display: flex;
    margin: 0px 10px;
    background: #fff;
    flex-wrap: wrap;
    justify-content: space-between;
    padding: 20px 35px;
    opacity: 0.9;
    border-radius: 8px;
    background-color: rgba(255, 255, 255, 1);
    box-shadow: 0px 4px 16px 0px rgba(26, 131, 212, 0.08);
  }
  .Name {
    color: rgba(153, 153, 153, 100);
    font-size: 14px;
    text-align: center;
    img {
      width: 14.44px;
      height: 14.44px;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .tabNumber {
    font-size: 22px;
    color: rgba(0, 0, 0, 0.85);
    text-align: center;
    font-weight: 600;
  }
  .solid_id {
    border-right: 1px solid rgba(241, 241, 241, 1);
  }
  .jifenRule {
    background: url('~@/assets/images/jifenRule.png') no-repeat;
    background-size: 100% 100%;
    margin: 20px 10px 0px 10px;
    border-radius: 8px 8px 0 0;
    display: flex;
    justify-content: space-between;
    padding: 0px 20px;

    .ruleNme {
      color: #fff;
      font-size: 18px;
      margin: 15px;
    }
    .ruleNme-font {
      color: #fff;
      font-size: 14px;
      margin: 20px 10px;
    }
  }
  .choice {
    height: 49px;
    line-height: 49px;
    border-bottom: 1px solid #e8e8e8;
    font-size: 15px;
    display: flex;
    justify-content: space-between;
    padding: 0 15px;
    background-color: #fff;
    margin: 0 10px;
    i {
      vertical-align: text-top;
      margin-left: 5px;
      font-size: 15px;
    }
    .choice-color {
      color: #fa9235;
    }
  }
  .bottom-box {
    min-height: 300px;
    background: #f0f5f9;
  }
  .tab_th {
    background: #fff;
    margin: 0px 10px;
    padding: 5px 25px;
    .title {
      color: rgba(0, 0, 0, 0.85);
      font-size: 16px;
      font-weight: 600;
      padding: 5px 0px;
    }
    .tab_tr {
      display: flex;
      justify-content: space-between;
    }
    .tab_lab {
      color: rgba(102, 102, 102, 100);
      font-size: 14px;
      padding: 5px 0px;
    }
    .received {
      width: 66px;
      height: 32px;
      line-height: 32px;
      border-radius: 16px;
      background-color: rgba(249, 114, 43, 1);
      color: rgba(255, 255, 255, 100);
      font-size: 15px;
      text-align: center;
    }
    /deep/.van-divider {
      margin: 0px;
    }
  }
}
.popimg {
  width: 280px;
  height: 110px;
}
.signsuccess {
  font-size: 16px;
  font-weight: 600;
  text-align: center;
}
.getsign {
  font-size: 16px;
  color: rgba(51, 51, 51, 100);
  text-align: center;
  margin: 10px 0px;
}
.vanbtn {
  width: 250px;
  margin: 10px 15px;
}
.text_van {
  font-size: 16px;
  color: rgba(51, 51, 51, 100);
  margin: 0px 10px;
  text-indent: 2em;
}
.text—span {
  font-size: 16px;
  color: rgba(51, 51, 51, 100);
  margin: 0px 10px;
  .item-point {
    padding-left: 20px;
    &::before {
      content: '';
      display: block;
      width: 8px;
      height: 8px;
      background: #fb9b38;
      border-radius: 50%;
      position: relative;
      top: 16px;
      left: -20px;
    }
  }
  .item-text {
    color: #666;
    padding-left: 20px;
    margin-top: 6px;
  }
}
.text-span1 {
  margin: 0 20px;
}
.text_rule {
  color: rgba(51, 51, 51, 100);
  font-size: 16px;
  text-align: center;
  font-weight: 600;
  margin: 15px 0px;
}
.progress {
  opacity: 0.9;
  border-radius: 8px;
  width: 100%;
  height: 6px;
  background-color: rgba(235, 235, 235, 1);
}
.proess_number {
  color: rgba(153, 153, 153, 100);
  font-size: 14px;
}
.ent_progress {
  background-image: linear-gradient(to right, #fb9b38, #f85823);
  height: 6px;
  position: absolute;
  top: 0px;
  left: 0;
  opacity: 0.9;
  border-radius: 8px;
}
.while_progress {
  width: 64px;
  position: relative;
}
</style>
